import * as React from "react";
import {changeProduct} from "./productSlice";
import {changeWorkQueue} from "../../WorkQueue/workQueueSlice";
import {updateCoveredProduct} from "./ProductClient";
import {Avatar, ListItemIcon, ListItemText, Menu, Tooltip} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ForwardIcon from "@mui/icons-material/Forward";
import ListIcon from "@mui/icons-material/List";
import Divider from "@mui/material/Divider";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import SearchIcon from "@mui/icons-material/Search";
import HelpIcon from "@mui/icons-material/Help";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {useDispatch, useSelector} from "react-redux";


export default function ProductResidualsMenu({row}) {

    const selectorSeriesId = useSelector((state) => state.productSlc.value.seriesExternalId);
    const selectorSeasonId = useSelector((state) => state.productSlc.value.seasonExternalId);
    const selectorSeasonNumber = useSelector((state) => state.productSlc.value.season);
    const selectorProductMcode = useSelector((state) => state.productSlc.value.mcode);
    const selectorProductName = useSelector((state) => state.productSlc.value.name);
    const selectorProductDescription = useSelector((state) => state.productSlc.value.description);
    const selectorProductCategory = useSelector((state) => state.productSlc.value.category);

    const selectorProductId = useSelector((state) => state.productSlc.value.id);

    const [residualAnchorEl, setResidualAnchorEl] = React.useState(null);


    const dispatchData = useDispatch();


    const isResidualMenuOpen = Boolean(residualAnchorEl);

    const handleResidualMenuOpen = (event) => {
        setResidualAnchorEl(event.currentTarget);
    };

    function handleResidualMenuClose()  {
        setResidualAnchorEl(null);
    };

    const handleAddGuilds = () => {
        dispatchData(changeProduct({guildMultiSelectState: true,
            bulkState: false}));
        console.log("guild dialogue should open now")
    };

    const handleCloneResiduals = () => {
    };

    const handleResidualsList = () => {
    };

    const handleGoToResiduals = (row) => {
        console.log("series Id to expand from product: ", selectorSeriesId);
        console.log("season Id to expand from product: ", selectorSeasonId);
        console.log("season number to expand from product: ", selectorSeasonNumber);
        console.log("product Id to expand from product: ", selectorProductId);
        dispatchData(changeWorkQueue({contractExpand: true,
            contractExpandHierarchical: selectorSeriesId !== null,
            contractExpandSeriesId: selectorSeriesId,
            contractExpandSeasonId: selectorSeasonId,
            contractExpandSeasonNumber: selectorSeasonNumber,
            contractExpandProductId: selectorProductId
        }));
        navigate('/Work');
    };

    const handleCovered = () => {
        console.log("updating this product", selectorProductId);
        updateCoveredProduct(selectorProductId, "Yes")
            .then(() => {
                dispatchData(changeProduct({productGridRefresh: true}));})
    };

    const handleNotCovered = () => {
        console.log("updating this product", selectorProductId);
        updateCoveredProduct(selectorProductId, "No")
            .then(() => {
                dispatchData(changeProduct({productGridRefresh: true}));})
    };

    const handleResearch = () => {
        console.log("updating this product", selectorProductId);
        updateCoveredProduct(selectorProductId, "Research")
            .then(() => {
                dispatchData(changeProduct({productGridRefresh: true}));})
    };

    const handleNoInfo = () => {
        console.log("updating this product", selectorProductId);
        updateCoveredProduct(selectorProductId, "No Info")
            .then(() => {
                dispatchData(changeProduct({productGridRefresh: true}));})
    };

    const handleClearInfo = () => {
        console.log("updating this product", selectorProductId);
        updateCoveredProduct(selectorProductId, "null")
            .then(() => {
                dispatchData(changeProduct({productGridRefresh: true}));})
    };

    const residualId = 'residual_menu';

    const renderResidualMenu = (
        <Menu
            anchorEl={residualAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={residualId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isResidualMenuOpen}
            onClose={handleResidualMenuClose}
        >

            <MenuItem
                onClick={handleAddGuilds}
            >
                <ListItemIcon>
                    <AddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Add Guilds</ListItemText>
            </MenuItem>
            <MenuItem
                onClick={handleCloneResiduals}
            >
                <ListItemIcon>
                    <PeopleAltIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Clone Contracts</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleGoToResiduals}>
                <ListItemIcon>
                    <ForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Go To Contracts</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleResidualsList}>
                <ListItemIcon>
                    <ListIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Contracts List</ListItemText>
            </MenuItem>
            <Divider/>
            <MenuItem onClick={handleCovered}>
                <ListItemIcon>
                    <CheckCircleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Covered</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleNotCovered}>
                <ListItemIcon>
                    <NotInterestedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Not Covered</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleResearch}>
                <ListItemIcon>
                    <SearchIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Research</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleNoInfo}>
                <ListItemIcon>
                    <HelpIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>No Info</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleClearInfo}>
                <ListItemIcon>
                    <HighlightOffIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Clear</ListItemText>
            </MenuItem>
        </Menu>
    );

    return (
        <div>
            <Tooltip enterDelay={1000} title={
                row.residuals > 0 ? "Residuals contracts exist on this title" :
                    row.coveredProduct === "Yes" ? "Covered Product" :
                        row.coveredProduct === "No" ? "Not Covered" :
                            row.coveredProduct === "Research" ? "Research Needed" :
                                row.coveredProduct === "No Info" ? "No Info Available" :
                                    "Undetermined"}>
                <Avatar
                    onClick={handleResidualMenuOpen}
                    variant="rounded"
                    sx={{ height: 23, width: 23, fontSize: 14, bgcolor:
                            row.residuals > 0 ? "rgb(30,144,255)" :
                                row.coveredProduct === "Yes" ? "green" :
                                    row.coveredProduct === "No" ? "black" :
                                        row.coveredProduct === "Research" ? "orange" :
                                            row.coveredProduct === "No Info" ? "red" :
                                                "white",
                        opacity:
                            row.residuals > 0 ? 1 :
                                row.coveredProduct === "Yes" ? 1:
                                    row.coveredProduct === "No" ? 1 :
                                        row.coveredProduct === "Research" ? 1 :
                                            row.coveredProduct === "No Info" ? 1 :
                                                0.1
                    }}
                >
                    {row.residuals > 0 ? "Re" :
                        row.coveredProduct === "Yes" ? "C":
                            row.coveredProduct === "No" ? "N" :
                                row.coveredProduct === "Research" ? "R" :
                                    row.coveredProduct === "No Info" ? "?" :
                                        " "}
                </Avatar>
            </Tooltip>
            {renderResidualMenu}
        </div>
    );

}